import React from 'react'
import './index.css';
import Property5 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property5 num="+91-2934572" type="Single Rustic Cabin" desc="Come and enjoy the experience of a single rustic cabin with your roommate. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Help in daily household chores like as washing dishes , cleaning etc." price = "0" guests="2" bed="1"  bath="1"/>
    </div>
  )
}

export default Property
